// removed by extract-text-webpack-plugin
module.exports = {"page":"_2ESLa","header":"_2Jd5Q","subheader":"_36NaM","text":"_2CGTY"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Page/index.sass
// module id = 1494
// module chunks = 1